module.exports = __webpack_public_path__ + "static/ClickedMedicalExpenses-b73727242f0f5c2e52c12a0cfb53726c.png";